import { render } from "./BasicRowMobile.vue?vue&type=template&id=07d9d6aa&scoped=true"
import script from "./BasicRowMobile.vue?vue&type=script&lang=js"
export * from "./BasicRowMobile.vue?vue&type=script&lang=js"

import "./BasicRowMobile.vue?vue&type=style&index=0&id=07d9d6aa&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d9d6aa"]])

export default __exports__